import type { IntlShape } from "@formatjs/intl";
import dayjs from "dayjs";

// Booking dates are plain calendar days; parsing them with dayjs keeps them on the
// same day in any time zone, where `new Date("2026-10-05")` would read them as UTC.
export const formatBookingDate = (intl: IntlShape, date: string) =>
  intl.formatMessage({ id: "short_date" }, { value: dayjs(date).toDate() });

export const formatBookingRange = (
  intl: IntlShape,
  startDate: string,
  endDate: string
) =>
  startDate === endDate
    ? formatBookingDate(intl, startDate)
    : `${formatBookingDate(intl, startDate)} – ${formatBookingDate(intl, endDate)}`;
